import { feedbackConstants } from '../_constants';

export function feedback(state = { fetchingDetail: false, detail: {} }, action) {
  switch (action.type) {
    case feedbackConstants.SUBMIT_REQUEST:
      return {
        ...state
      };
    case feedbackConstants.SUBMIT_SUCCESS:
      return {
        ...state,
        detail: action.detail
      };
    case feedbackConstants.SUBMIT_FAILURE:
      return {
        ...state
      };
    default:
      return state;
  }
}
